<template>
  <footer class="my-1 pt-0 text-muted text-center text-small">
    <div class="row justify-content-center m-1">
      <div class="text-center">
        <b>{{ $t('current_instance') }}</b>
        {{ current_instance }}
      </div>
    </div>    
    <p class="mb-1">&copy; EnergyAIMS</p>
    <!--ul class="list-inline">
      <li class="list-inline-item"><a href="#">Privacy</a></li>
      <li class="list-inline-item"><a href="#">Terms</a></li>
      <li class="list-inline-item"><a href="#">Support</a></li>
    </ul-->
  </footer>
</template>

<script>
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const current_instance = store.getters.currentInstance;

    return {
      current_instance
    }    
  }
}
</script>